import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { toast } from "sonner";
import { createLead } from "../lib/api";

export default function LeadDialog({ open, onOpenChange, source, sourceTitle, eyebrow = "Reserve your spot", cta = "Reserve" }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await createLead({
        source,
        source_title: sourceTitle,
        customer_name: name,
        customer_email: email,
        notes: notes || null,
      });
      toast.success("You're on the list.", {
        description: `Lucas's team will follow up about "${sourceTitle}" shortly.`,
      });
      onOpenChange(false);
      setName("");
      setEmail("");
      setNotes("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-obsidian-700 border-white/10 text-white rounded-none" data-testid="lead-dialog">
        <DialogHeader>
          <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-gold-400">{eyebrow}</div>
          <DialogTitle className="font-bebas text-3xl uppercase leading-none tracking-wide">
            {sourceTitle}
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 pt-3">
          <div>
            <Label className="text-zinc-400 uppercase tracking-widest text-[10px]">Full name</Label>
            <Input
              data-testid="lead-name-input"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="bg-obsidian-900 border-white/10 text-white rounded-none mt-1"
            />
          </div>
          <div>
            <Label className="text-zinc-400 uppercase tracking-widest text-[10px]">Email</Label>
            <Input
              data-testid="lead-email-input"
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-obsidian-900 border-white/10 text-white rounded-none mt-1"
            />
          </div>
          <div>
            <Label className="text-zinc-400 uppercase tracking-widest text-[10px]">
              Anything Lucas should know? <span className="text-zinc-600">(optional)</span>
            </Label>
            <Input
              data-testid="lead-notes-input"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Skill level, hat size, timezone, etc."
              className="bg-obsidian-900 border-white/10 text-white rounded-none mt-1"
            />
          </div>
          <p className="text-[11px] text-zinc-500 font-mono">
            No spam. We only email you about this specific inquiry.
          </p>
          <Button
            type="submit"
            disabled={loading}
            data-testid="lead-submit-btn"
            className="w-full bg-gradient-to-r from-gold-400 to-gold-500 text-black hover:brightness-110 rounded-none font-bebas text-lg tracking-widest uppercase"
          >
            {loading ? "Sending..." : cta}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
